<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text"
        >{{ $t('text.admin').toUpperCase() }} -
        {{ $t('text.data_privacy').toUpperCase() }}</span
      >
    </div>
    <div class="page-card-content">
      <div class="pt-20 page-content">
        <div>
          <div class="section-title mb-15">
            {{ $t('text.system_data_rentenion') }}
          </div>
          <el-row class="mb-5 dark-grey-font">
            <el-col :xs="24" :sm="12"
              >{{ $t('text.maximum_inactivity_data_retention_period') }} ({{
                $t('text.default')
              }})</el-col
            >
            <el-col :xs="24" :sm="12" class="text-right">
              <el-input-number
                v-model="maximum_period"
                controls-position="right"
                class="mr-10"
                size="mini"
              ></el-input-number
              >{{ $t('text.months') }}
            </el-col>
          </el-row>
          <div>
            <div>{{ $t('text.system_data_rentenion_desc') }}</div>
            <div v-html="$t('text.data_rentenion_detail')"></div>
            <el-button
              type="success"
              plain
              :loading="changeSystemRetentionLoading"
              @click="changeSystemRetention()"
              class="common-btn mt-20"
              v-if="p('Manage Module.Super Admin.Data Privacy.Save')"
              >{{ $t('text.save_preference') }}</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      maximum_period: 12,
      userRolesTimer: '',
      user: JSON.parse(localStorage.getItem('user')),
      changeSystemRetentionLoading: false
    }
  },
  mounted() {
    this.maximum_period = this.user.systemRetentionPeriod
  },
  methods: {
    changeSystemRetention() {
      this.changeSystemRetentionLoading = true
      ApiService.ChangeSystemRetention(this.maximum_period)
        .then(response => {
          this.changeSystemRetentionLoading = false
          if (response.data.success) {
            this.updateUserLocalstorage()
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.saved_failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.changeSystemRetentionLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.saved_failed')
          })
        })
    },
    updateUserLocalstorage() {
      this.user.systemRetentionPeriod = this.maximum_period
      localStorage.setItem('user', JSON.stringify(this.user))
      this.$store.commit('user/SET_USER_DATA', this.user)
    }
  }
}
</script>
